import Bus from '@/views/Bus/index.vue'

const BusRouter = {
  path: '/bus',
  name: 'Bus',
  component: Bus,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default BusRouter
